// extracted by mini-css-extract-plugin
module.exports = {"grid":"BetonIncomeModal_grid__gyE4s","exp":"BetonIncomeModal_exp__3RVNF","history":"BetonIncomeModal_history__fFCKN","headline":"BetonIncomeModal_headline__1frOP"};